import { graphql } from "relay-runtime"

export const consultationReportFragment = graphql`
  fragment consultationReportFragment on ch_ConsultationReport {
    id
    progressNoteId
    patientId
    createdAt
    createdBy
    updatedAt
    updatedBy
    fileId
    signedAt
    signedBy
    concludedAt
    concludedBy
    sentAt
    sentBy
    language
    healthcareProviderId
    diagnosisCode
    anamnesis
    recommendedTreatment
    isAiGenerated
    isAiContentModified
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
